import { IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";

import './Main.css'; 

const Media : React.FC = () => {

    return (
        <IonPage>
            <IonContent>
                <div id="border-bk" />
                <IonToolbar color="none">
                    
                </IonToolbar>
                <IonCard className="ion-padding">
                    Media
                </IonCard>
            </IonContent>
        </IonPage>
    );
};

export default Media;